import { userApi } from '@/api'
import { tokenStorage, userStorage } from '@/utils/storage'

export default {
  namespaced: true,
  
  state: {
    token: tokenStorage.get() || '',
    userInfo: userStorage.get() || null,
    isLogin: !!tokenStorage.get()
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      tokenStorage.set(token)
      state.isLogin = true
    },
    
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      userStorage.set(userInfo)
    },
    
    CLEAR_USER(state) {
      state.token = ''
      state.userInfo = null
      state.isLogin = false
      tokenStorage.remove()
      userStorage.remove()
    }
  },
  
  actions: {
    async login({ commit }, loginData) {
      const data = await userApi.login(loginData)
      commit('SET_TOKEN', data.token)
      commit('SET_USER_INFO', data.userInfo)
      return data
    },
    
    async getUserInfo({ commit, state }) {
      if (!state.token) return null
      const data = await userApi.getUserInfo()
      commit('SET_USER_INFO', data)
      return data
    },
    
    async logout({ commit }) {
      try {
        await userApi.logout()
      } catch (error) {
        console.log(error)
      }
      commit('CLEAR_USER')
    },
    
    async register({ dispatch }, registerData) {
      const data = await userApi.register(registerData)
      await dispatch('login', {
        username: registerData.username,
        password: registerData.password
      })
      return data
    }
  },
  
  getters: {
    isLogin: state => state.isLogin,
    userInfo: state => state.userInfo,
    token: state => state.token
  }
}